"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _uuid = _interopRequireDefault(require("uuid"));

require("./HMPTextArea.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class HMPTextArea extends _react.Component {
  constructor(props) {
    super(props);

    this.onChange = event => {
      event.stopPropagation();
      const {
        onChange
      } = this.props;

      if (onChange) {
        onChange(event);
      }
    };

    this.characterLimit = (s, limit) => {
      if (s) {
        if (s.length <= limit) {
          return `(${limit - s.length} characters left.)`;
        }

        return `(${s.length - limit} characters over character limit.)`;
      }

      return `(${limit} characters left)`;
    };

    this.key = (0, _uuid.default)();
  }

  render() {
    const {
      value,
      key,
      rows,
      maxRows,
      minRows,
      onHeightChange,
      placeholder,
      characterLimit,
      spellCheck,
      style,
      className,
      useCacheForDOMMeasurements,
      disabled
    } = this.props;
    const displayCharacterLimit = characterLimit !== undefined && characterLimit > 0;
    let exceedsCharacterLimit = false;
    let characterLimitMessage = '';

    if (value && displayCharacterLimit) {
      if (value && characterLimit && value.length > characterLimit) {
        exceedsCharacterLimit = true;
      }

      characterLimitMessage = `${value.length}/${characterLimit}`;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "textarea-container"
    }, /*#__PURE__*/_react.default.createElement(_reactTextareaAutosize.default, {
      key: key || this.key,
      value: value,
      rows: rows,
      maxRows: maxRows,
      minRows: minRows,
      onChange: this.onChange,
      onHeightChange: onHeightChange,
      placeholder: placeholder,
      spellCheck: spellCheck,
      style: style,
      className: [className || '', 'textarea', `${exceedsCharacterLimit ? 'error' : ''}`].join(' '),
      useCacheForDOMMeasurements: useCacheForDOMMeasurements,
      disabled: disabled
    }), displayCharacterLimit && /*#__PURE__*/_react.default.createElement("span", {
      className: ['textarea-after', `${exceedsCharacterLimit ? 'error' : ''}`].join(' ')
    }, characterLimitMessage));
  }

}

var _default = HMPTextArea;
exports.default = _default;